import {
  MFASendSMSRequest,
  MFASendSMSResponse,
  MFASetupResponse,
  MFASetupSMSRequest,
  MFASetupSMSResponse,
  MFASetupTOTPVerifyRequest,
  MFAVerifyRequest,
  MFAVerifyResponse,
} from '@gtintel/signin/types/mfa.types';
import { api } from './api';

class MFAService {
  async verifyMFA(data: MFAVerifyRequest): Promise<MFAVerifyResponse> {
    const response = await api.post<MFAVerifyResponse>('/mfa/verify', data);
    return response.data;
  }

  async sendSMS(temporaryToken: string): Promise<MFASendSMSResponse> {
    const request: MFASendSMSRequest = { temporary_token: temporaryToken };
    const response = await api.post<MFASendSMSResponse>('/mfa/send-sms', request);
    return response.data;
  }

  async getTOTPSetup(): Promise<MFASetupResponse> {
    const response = await api.get<MFASetupResponse>('/mfa/setup/totp');
    return response.data;
  }

  async verifyTOTPSetup(data: MFASetupTOTPVerifyRequest): Promise<any> {
    const response = await api.post('/mfa/setup/totp/verify', data);
    return response.data;
  }

  async setupSMS(phoneNumber: string): Promise<MFASetupSMSResponse> {
    const request: MFASetupSMSRequest = { phone_number: phoneNumber };
    const response = await api.post<MFASetupSMSResponse>('/mfa/setup/sms', request);
    return response.data;
  }
}

export const mfaService = new MFAService();
